export type DisplayState = 'INTRO' | 'QUESTION_MODE' | 'CONCLUSION';
export interface AssessmentMetaData {
  clientDetails: Details;
  advisorDetails: Details & { firmName: string; firmLogo: string };
  firmName: string;
}

export interface Details {
  firstName: string;
  lastName: string;
  email: string;
}

export interface ErrorObject {
  valid: boolean;
  message: string;
}

export const DEFAULT_ERROR_STATE = { message: '', valid: false };
